module.exports = __webpack_public_path__ + "img/91.6ce2c034.jpg";